import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import StoreLocationForm from './StoreLocationForm';

export interface StoreOnboardingDialogProps {
  stores: Array<{ storeId: string; name: string }>;
  open: boolean;
  onClose: () => void;
}

const StoreOnboardingDialog: React.FC<StoreOnboardingDialogProps> = ({ stores, open, onClose }) => {
  const [index, setIndex] = useState(0);
  // The form's save button renders here, at the far left of the fixed footer (Jason, 29 Oct 2026)
  const [saveSlot, setSaveSlot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (open) setIndex(0);
  }, [open, stores]);

  const current = stores[index];
  if (!current) return null;
  const isLast = index >= stores.length - 1;

  const next = () => (isLast ? onClose() : setIndex(index + 1));

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{`Set up store ${index + 1} of ${stores.length} — ${current.name}`}</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 2 }}>
          These stores have no address yet. Uber uses this address as the pickup point. Anything you skip comes back next time you sync stores.
        </Typography>
        <StoreLocationForm
          key={current.storeId}
          storeId={current.storeId}
          showMakeLive
          submitLabel={isLast ? 'Save and finish' : 'Save and next'}
          onSaved={next}
          actionsContainer={saveSlot}
        />
      </DialogContent>
      <DialogActions>
        <Box ref={setSaveSlot} sx={{ mr: 'auto' }} />
        <Button onClick={next}>Skip for now</Button>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default StoreOnboardingDialog;
